import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-format-more",
  "use": "icon-format-more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-format-more\">\n<circle cx=\"12\" cy=\"12\" r=\"2\" fill=\"currentColor\" />\n<circle cx=\"6\" cy=\"12\" r=\"2\" fill=\"currentColor\" />\n<circle cx=\"18\" cy=\"12\" r=\"2\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol